export const ANALYTICS_OUTLINK_SELECTED = 'ANALYTICS_OUTLINK_SELECTED';
export const analyticsOutlinkSelected = url => ({type: ANALYTICS_OUTLINK_SELECTED, url});


/** WEBPACK FOOTER **
 ** ./src/members/state/analytics/actions.js
 **/